$(function() {

    var _reportContainer = $('#report-builder');

    if (!_reportContainer.length > 0) {
        return;
    }

    var csrfToken = $('#csrf-token').attr('value');
    var _form = _reportContainer.parents('form');
    var _submitBtn = _form.find('button[type="submit"]');
    var _rulesInput = _form.find('input[name="rules"]');
    var _sourceSelect = _form.find('select[name="source"]');

    var _loading = $('#report-loading');
    var _dataToReturn = $('#report-data-to-return');
    var _dataSelectAll = $('.data-select-all');
    var _dataDeselectAll = $('.data-deselect-all');
    var _dataSorting = $('#report-data-sorting');
    var _reportFilters = $('#report-filters');
    var _sortOptionsSelect = $('select[name="sort_by"]');
    var _sortDirectionSelect = $('select[name="sort_dir"]');
    var errMessageTimeout;

    var buildColumns = function(columns) {

        _dataToReturn.find('form-group').not('.section-fieldtype').remove();

        $.each(columns, function(idx, column) {

            var markup = '<div class="form-group checkboxes-fieldtype w-1/3 py-0">' +
                '<div class="field-inner">' +
                    '<ul class="list-unstyled">' +
                        '<li>' +
                            '<input type="checkbox" name="columns[]" id="columns-' + column.value + '" value="' + column.value + '" checked>' +
                            '<label for="columns-' + column.value + '">' + column.label + '</label>' +
                        '</li>' +
                    '</ul>' +
                '</div>' +
            '</div>';

            $(markup).appendTo(_dataToReturn.find('.publish-fields'));
        });
    };

    var updateSortOptions = function(sortOptions) {

        _sortOptionsSelect.find('option').remove();

        $('<option value="">Please select...</option>').appendTo(_sortOptionsSelect);

        $.each(Object.keys(sortOptions), function(idx, option) {
            $('<option value="' + option + '">' + sortOptions[option] + '</option>').appendTo(_sortOptionsSelect);
        });
    };

    var hideSourceInformation = function() {
        _submitBtn.attr('disabled', '');
        _sourceSelect.removeAttr('disabled');
        _loading.css('display', 'none');
        _dataToReturn.css('display', 'none');
        _dataSorting.css('display', 'none');
        _reportFilters.css('display', 'none');
    };

    var getSourceInformation = function(source, callback) {

        if (errMessageTimeout) {
            clearTimeout(errMessageTimeout);
        }

        _loading.find('.help-block').text('Please wait...');
        _loading.css('display', 'block');
        _sourceSelect.attr('disabled', '');

        $.ajax({
            method: 'POST',
            dataType: 'json',
            headers: {
                'X-CSRF-TOKEN': csrfToken,
            },
            url: '/manage/addons/membership/reporting/source-options',
            data: {
                source: source
            }
        })
        .done(function(response) {

            _submitBtn.removeAttr('disabled');
            _sourceSelect.removeAttr('disabled');

            buildColumns(response.columns);
            updateSortOptions(response.sort_options);

            _reportContainer.queryBuilder('destroy');

            _reportContainer.queryBuilder({
                filters: response.rules
            });

            _loading.css('display', 'none');
            _dataToReturn.css('display', 'block');
            _dataSorting.css('display', 'block');
            _reportFilters.css('display', 'block');

            if (typeof callback === 'function') {
                callback();
            }
        })
        .fail(function(err) {

            hideSourceInformation();

            _loading.find('.help-block').text('An error occurred, please try again.');
            _loading.css('display', 'block');

            errMessageTimeout = setTimeout(function() {
                _loading.css('display', 'none');
            }, 5000);
        });
    };

    _sourceSelect.on('change', function(e) {

        var selected = e.target.value;

        hideSourceInformation();

        if (selected.length > 0) {
            getSourceInformation(selected);
            return;
        }
    });

    _dataSelectAll.on('click', function(e) {
        e.preventDefault();
        $('input[name="columns[]"]').prop('checked', true);
    });

    _dataDeselectAll.on('click', function(e) {
        e.preventDefault();
        $('input[name="columns[]"]').prop('checked', false);
    });

    _form.on('submit', function(e) {

        e.preventDefault();

        var selectedColumns = $('input[name="columns[]"]:checked').length;

        if (selectedColumns < 1) {
            _dataToReturn[0].scrollIntoView();
            return;
        }

        var hasSort = _sortOptionsSelect.val().length > 0;
        var hasSortDir = _sortDirectionSelect.val().length > 0;

        if (!hasSort) {
            _sortOptionsSelect[0].scrollIntoView();
            _sortOptionsSelect[0].focus();
            return;
        }

        if (!hasSortDir) {
            _sortDirectionSelect[0].scrollIntoView();
            _sortDirectionSelect[0].focus();
            return;
        }

        var parsedRules = _reportContainer.queryBuilder('getRules');

        if (!parsedRules || parsedRules.valid !== true) {
            _reportFilters[0].scrollIntoView();
            return;
        }

        if (!$.isEmptyObject(parsedRules)) {
            _rulesInput.val(JSON.stringify(parsedRules));

            _form[0].submit();
        }
    });

    if (_sourceSelect.val().length > 0) {

        hideSourceInformation();

        getSourceInformation(_sourceSelect.val(), function() {

            var mrOptions = window.MembershipReporting;

            if (mrOptions) {
                _sortOptionsSelect.val(mrOptions.sortBy);
                _sortOptionsSelect.trigger('change');

                _sortDirectionSelect.val(mrOptions.sortDir);
                _sortDirectionSelect.trigger('change');

                if (mrOptions.columns) {
                    $('input[name="columns[]"]').each(function(idx, el){

                        var _el = $(el);

                        if (mrOptions.columns.indexOf(_el.val()) > -1) {
                            _el.attr('checked', '');
                        } else {
                            _el.removeAttr('checked');
                        }
                    });
                }

                _reportContainer.queryBuilder('setRules', mrOptions.rules);
            }
        });
    }
});